module.exports = __webpack_public_path__ + "img/android.67ff9c02.png";